import { keyframes, styled } from "../stitches.config";

export function Loading() {
  return (
    <Container>
      <Dot1 />
      <Dot2 />
      <Dot3 />
    </Container>
  );
}

const Container = styled("div", {
  display: "inline-flex",
});

const breath = keyframes({
  "0%, 100%": {
    opacity: 1,
  },
  "50%": {
    opacity: 0.5,
  },
});

const Dot = styled("div", {
  borderRadius: "50%",
  width: "$1",
  height: "$1",
  "&:not(:first-child)": {
    marginLeft: "$1",
  },
  background: "$paper10",
  animation: `${breath} 1.2s linear infinite`,
});

const Dot1 = styled(Dot, {
  animationDelay: "0s",
});

const Dot2 = styled(Dot, {
  animationDelay: "-0.4s",
});

const Dot3 = styled(Dot, {
  animationDelay: "-0.8s",
});
